import type { Tokens } from '../../../../theming/types'

const badgeStyles = (size: string) => ({
  badge: {
    height: size,
    width: size,
  },
})

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      badge: {
        backgroundColor: tokens.statusBgColorAlert,
      },
    },

    sizeXxlarge: badgeStyles('20px'),
    sizeXlarge: badgeStyles('18px'),
  } as const
}
